/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { EmbeddedTelemetryViewer } from '@/components/EmbeddedTelemetryViewer/EmbeddedTelemetryViewer';

export type NodeDetailsTelemetryProps = {
  nodeId: string;
};

export function NodeDetailsTelemetry({ nodeId }: NodeDetailsTelemetryProps) {
  return (
    <div data-testid="node-details-telemetry">
      <EmbeddedTelemetryViewer
        nodeId={nodeId}
        iframeStyle={{
          width: '100%',
          height: 'calc(100vh - 320px)',
          minHeight: '600px',
          border: 'none',
        }}
      />
    </div>
  );
}
